import ScopedBlogList from '@/components/blog/scoped-blog-list';
import { ROUTES } from '@/config/routes';
import { adminSidebar } from '@/config/sidebarConfig';

export default function AdminBlog() {
  return (
    <ScopedBlogList
      sidebarConfig={adminSidebar}
      createRoute={ROUTES.ADMIN_BLOG_CREATE}
      editRouteBase='/admin/blog'
      subtitle='Gestion des articles'
      showAuthor
    />
  );
}
